import { connect } from 'react-redux';
import { getAdminText100 } from 'services/themes';
import MediaLibrary from './MediaLibrary';

const mapStateToProps = state => ({
  adminText100: getAdminText100(state),
});

export default connect(mapStateToProps)(MediaLibrary);
